import React from 'react';
import ReactLoading from 'react-loading';

const LoadingIndicator = ({ type, color, height, width }) => (
    <ReactLoading type={type || 'bars'} color={color || '#FFF'} height={height || '20%'} width={width || '20%'} />
);

export default LoadingIndicator;
